import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3172a282")

_pushScopeId("data-v-3172a282")
const _hoisted_1 = { class: "settings-default-wrap" }
const _hoisted_2 = { class: "settings-default" }
const _hoisted_3 = { class: "screen-wrap" }
const _hoisted_4 = {
  key: 1,
  class: "setting-wrap"
}
const _hoisted_5 = { class: "popup-content" }
const _hoisted_6 = { class: "popup-text-block" }
const _hoisted_7 = { class: "popup-title" }
const _hoisted_8 = { class: "popup-text" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Ok")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Logo = _resolveComponent("Logo")
  const _component_ScreenSettings = _resolveComponent("ScreenSettings")
  const _component_ExpandedSettings = _resolveComponent("ExpandedSettings")
  const _component_ChangeLayout = _resolveComponent("ChangeLayout")
  const _component_MenuSettings = _resolveComponent("MenuSettings")
  const _component_MobileExpandedSettings = _resolveComponent("MobileExpandedSettings")
  const _component_Drawer = _resolveComponent("Drawer")
  const _component_Button = _resolveComponent("Button")
  const _component_Popup = _resolveComponent("Popup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (!_ctx.isMobileScreen)
        ? (_openBlock(), _createBlock(_component_Logo, {
            key: 0,
            class: "admin-logo",
            size: "medium"
          }))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_ScreenSettings, {
          class: "screen-default",
          deviceError: _ctx.deviceError,
          conference: _ctx.conference
        }, null, 8, ["deviceError", "conference"])
      ]),
      (!_ctx.isMobileScreen)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_ExpandedSettings, {
              class: "panel-default",
              deviceError: _ctx.deviceError
            }, null, 8, ["deviceError"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Drawer, null, {
      default: _withId(() => [
        (_ctx.drawerStore.section === 'changeLayout')
          ? (_openBlock(), _createBlock(_component_ChangeLayout, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.drawerStore.section === 'settings')
          ? (_openBlock(), _createBlock(_component_MenuSettings, {
              key: 1,
              class: "menu-drawer",
              isMenu: true,
              mode: "default"
            }))
          : _createCommentVNode("", true),
        (_ctx.drawerStore.section === 'generalSettings')
          ? (_openBlock(), _createBlock(_component_MobileExpandedSettings, {
              key: 2,
              deviceError: _ctx.deviceError
            }, null, 8, ["deviceError"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.popupOpened)
      ? (_openBlock(), _createBlock(_component_Popup, {
          key: 0,
          class: "popup-assess"
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode("img", {
                class: "allow-devices-img",
                src: _ctx.allowDevicesImg
              }, null, 8, ["src"]),
              _createVNode("div", _hoisted_6, [
                _createVNode("p", _hoisted_7, _toDisplayString(_ctx.t('error.browserPermission.popUpTitle')), 1),
                _createVNode("p", _hoisted_8, _toDisplayString(_ctx.t('error.browserPermission.popUpDescription')), 1),
                _createVNode(_component_Button, {
                  size: "m",
                  mode: "secondary",
                  width: "fill-container",
                  onClick: _ctx.closePopup
                }, {
                  default: _withId(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
})